import React, { useState, useEffect, useContext, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from './components/Login/AuthContext';
import PublicSummaryTool from './components/Tools/PublicSummaryTool';
import UpgradePrompt from './components/App/Generator/UpgradePrompt';
import './styles/button.css'
import './styles/style.css'
import './styles/form.css'
import Login from './components/Login/Login';
import LoginWithToken from './components/Login/LoginWithToken';



// Lazy loading des pages de l'app  
import Legal from './components/Page/Legal';
import YTThumbnail from './components/Tools/YTThumbnail';

// Lazy loading des pages de l'app
const BlogPage = lazy(() => import('./components/App/Pages/BlogPage'));
const TweetPage = lazy(() => import('./components/App/Pages/TweetPage'));
const NewsletterPage = lazy(() => import('./components/App/Pages/NewsletterPage'));
const LinkedinPage = lazy(() => import('./components/App/Pages/LinkedinPage'));
const CustomPage = lazy(() => import('./components/App/Pages/CustomPage'));
const SummaryPage = lazy(() => import('./components/App/Pages/SummaryPage'));
const PodcastPage = lazy(() => import('./components/App/Pages/PodcastPage'));
const GenerationsPage = lazy(() => import('./components/App/Pages/GenerationsPage'));
const SettingsPage = lazy(() => import('./components/App/Pages/SettingsPage'));
const StylesPage = lazy(() => import('./components/App/Pages/StylesPage'));

const AppRouter = () => {
    const { isAuthenticated, isLoading } = useContext(AuthContext);

    // Afficher un loader pendant la vérification de l'authentification
    if (isLoading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;
    }

    return (
        <Router>
            <Routes>


                <Route path="/youtube_summary" element={<PublicSummaryTool />} />
                <Route
                    path="/"
                    element={<Navigate to="/app" replace />}
                />

                {/* Redirect /app to /app/blog */}
                <Route
                    path="/app"
                    element={<Navigate to="/app/tweet" replace />}
                />

                {/* App routes with authentication */}

                <Route
                    path="/app/blog"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <BlogPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/blog/:id"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <BlogPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />

                <Route
                    path="/app/tweet"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <TweetPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/tweet/:id"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <TweetPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/newsletter"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <NewsletterPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/newsletter/:id"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <NewsletterPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/linkedin"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <LinkedinPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/linkedin/:id"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <LinkedinPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/custom"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <CustomPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/custom/:id"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <CustomPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/summary"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <SummaryPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/summary/:id"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <SummaryPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/podcast"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <PodcastPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/podcast/:id"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <PodcastPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/generations"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <GenerationsPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/settings"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <SettingsPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />
                <Route
                    path="/app/styles"
                    element={
                        isAuthenticated ? (
                            <Suspense fallback={<div>Loading...</div>}>
                                <StylesPage />
                            </Suspense>
                        ) : (
                            <Navigate to="/login" />
                        )
                    }
                />

                <Route
                    path="/legal"
                    element={<Legal />}
                />
                <Route
                    path="/login"
                    element={isAuthenticated ? <Navigate to="/app" /> : <Login />}
                />

                <Route
                    path="/login_with_token"
                    element={isAuthenticated ? <Navigate to="/app" /> : <LoginWithToken />}
                />

                <Route path="/youtube_thumbnail_downloader" element={<YTThumbnail />} />
                <Route path="/checkout" element={
                    <Suspense fallback={<div>Loading...</div>}>
                        <UpgradePrompt autoCheckout={true} />
                    </Suspense>
                } />
            </Routes>
        </Router>
    );
};

export default AppRouter;
